import type { ExecutionOptions } from "@/services/generationOptions";

export interface AUGCRecord {
  id: string;
  userId: string;
  userName: string;
  templateId: string;
  templateName: string;
  templateType: "style" | "pure";
  styleName?: string;
  sceneType?: string;
  imageUrl?: string;
  status: "success" | "processing" | "failed";
  createdAt: string;
  generateTime: number;
  faceScore?: number;
  canRegenerate?: boolean;
  regenerating?: boolean;
  regenerateUnavailableReason?: string;
  regenerationError?: string;
  currentAttemptId?: string;
  executionOptions?: ExecutionOptions;
  useCutout?: boolean;
  retryIdempotencyKey?: string;
  pipeline?: string;

  provider?: "wan" | "facefusion";
  stage?:
    | "cutout_queued"
    | "cutout_processing"
    | "provider_queued"
    | "provider_running"
    | "provider_retry_wait"
    | "result_pending"
    | "result_processing"
    | "generation_retry_queued"
    | "published"
    | "failed";
  validationPolicyId?: "wan-photo-v1" | "direct-publish-v1" | string;
  validationEnabled?: boolean;
  generationAttempt?: number;
  maxGenerationAttempts?: number;
  validationScore?: number;
  validationThreshold?: number;
  lastError?: string;
}

export const augcHistoryStats = {
  todayGenerated: 342,
  todaySuccess: 338,
  todayFailed: 4,
  avgTime: 2.8,
  totalUsers: 128,
  totalRecords: 4521,
};

export const augcRecords: AUGCRecord[] = [
  {
    id: "r1",
    userId: "u1",
    userName: "张小明",
    templateId: "p1",
    templateName: "三峡大坝全景",
    templateType: "pure",
    sceneType: "山水风景",
    imageUrl: "/assets/img/13e71b0e20fec304.jpg",
    status: "success",
    stage: "published",
    provider: "wan",
    currentAttemptId: "r1",
    executionOptions: { model: "wan2.7-image" },
    canRegenerate: true,
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    validationScore: 0.8524,
    validationThreshold: 0.4,
    createdAt: "2026-06-01 14:32:05",
    generateTime: 2.4,
    faceScore: 96,
  },
  {
    id: "r2",
    userId: "u2",
    userName: "李芳华",
    templateId: "s1",
    templateName: "鲟侠船长",
    templateType: "style",
    styleName: "Q版萌系",
    imageUrl: "/assets/img/4921b4b4e19e1693.jpg",
    status: "success",
    stage: "published",
    provider: "facefusion",
    currentAttemptId: "r2",
    canRegenerate: true,
    validationPolicyId: "direct-publish-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    createdAt: "2026-06-01 14:28:12",
    generateTime: 1.8,
    faceScore: 94,
  },
  {
    id: "r3",
    userId: "u3",
    userName: "王建国",
    templateId: "p4",
    templateName: "白帝城晨曦",
    templateType: "pure",
    sceneType: "名胜古迹",
    status: "processing",
    stage: "result_pending",
    provider: "wan",
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    createdAt: "2026-06-01 14:15:33",
    generateTime: 0,
  },
  {
    id: "r4",
    userId: "u4",
    userName: "赵秀英",
    templateId: "p5",
    templateName: "三峡日出",
    templateType: "pure",
    sceneType: "日出日落",
    status: "processing",
    stage: "result_processing",
    provider: "wan",
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    createdAt: "2026-06-01 13:58:47",
    generateTime: 0,
  },
  {
    id: "r5",
    userId: "u5",
    userName: "陈志强",
    templateId: "s4",
    templateName: "大坝实景",
    templateType: "style",
    styleName: "写实风格",
    status: "processing",
    stage: "generation_retry_queued",
    provider: "wan",
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 2,
    maxGenerationAttempts: 3,
    validationScore: 0.3421,
    validationThreshold: 0.4,
    lastError: "identity_below_threshold: Similarity score 0.3421 below threshold 0.40",
    createdAt: "2026-06-01 13:42:19",
    generateTime: 0,
  },
  {
    id: "r6",
    userId: "u6",
    userName: "刘佳怡",
    templateId: "p7",
    templateName: "三峡夜景",
    templateType: "pure",
    sceneType: "城市风光",
    status: "processing",
    stage: "provider_running",
    provider: "wan",
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    createdAt: "2026-06-01 13:35:00",
    generateTime: 0,
  },
  {
    id: "r7",
    userId: "u7",
    userName: "孙伟",
    templateId: "s7",
    templateName: "游船卡通",
    templateType: "style",
    styleName: "卡通插画",
    status: "processing",
    stage: "result_pending",
    provider: "facefusion",
    validationPolicyId: "direct-publish-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    createdAt: "2026-06-01 13:20:55",
    generateTime: 0,
  },
  {
    id: "r8",
    userId: "u8",
    userName: "周敏",
    templateId: "p2",
    templateName: "巫山神女峰",
    templateType: "pure",
    sceneType: "山水风景",
    status: "failed",
    stage: "failed",
    provider: "wan",
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 3,
    maxGenerationAttempts: 3,
    validationScore: 0.312,
    validationThreshold: 0.4,
    lastError: "identity_below_threshold: Maximum 3 generation attempts exhausted",
    canRegenerate: true,
    createdAt: "2026-06-01 13:15:22",
    generateTime: 5.0,
  },
  {
    id: "r9",
    userId: "u9",
    userName: "吴磊",
    templateId: "p3",
    templateName: "长江三峡游船",
    templateType: "pure",
    sceneType: "城市风光",
    imageUrl: "/assets/img/45a7dabbe8e2c13f.jpg",
    status: "success",
    stage: "published",
    provider: "wan",
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    validationScore: 0.88,
    validationThreshold: 0.4,
    createdAt: "2026-06-01 12:48:10",
    generateTime: 2.9,
    faceScore: 93,
  },
  {
    id: "r10",
    userId: "u10",
    userName: "郑雪",
    templateId: "s10",
    templateName: "水墨神女",
    templateType: "style",
    styleName: "水墨国风",
    status: "processing",
    stage: "provider_queued",
    provider: "wan",
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    createdAt: "2026-06-01 12:30:45",
    generateTime: 0,
  },
  {
    id: "r11",
    userId: "u11",
    userName: "马超",
    templateId: "p6",
    templateName: "瞿塘峡夔门",
    templateType: "pure",
    sceneType: "山水风景",
    imageUrl: "/assets/img/f3cc59dd130955d7.jpg",
    status: "success",
    stage: "published",
    provider: "wan",
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    validationScore: 0.92,
    validationThreshold: 0.4,
    createdAt: "2026-06-01 12:15:08",
    generateTime: 2.3,
    faceScore: 97,
  },
  {
    id: "r12",
    userId: "u12",
    userName: "林雨桐",
    templateId: "s11",
    templateName: "油画三峡",
    templateType: "style",
    styleName: "油画质感",
    status: "processing",
    stage: "provider_retry_wait",
    provider: "wan",
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    lastError: "wan_backend_timeout: Temporary timeout waiting for Wan worker slot",
    createdAt: "2026-06-01 11:52:33",
    generateTime: 0,
  },
  {
    id: "r13",
    userId: "u13",
    userName: "黄涛",
    templateId: "p8",
    templateName: "屈原故里",
    templateType: "pure",
    sceneType: "名胜古迹",
    imageUrl: "/assets/img/c951068824cb6647.jpg",
    status: "success",
    stage: "published",
    provider: "facefusion",
    validationPolicyId: "direct-publish-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    createdAt: "2026-06-01 11:30:00",
    generateTime: 2.0,
    faceScore: 94,
  },
  {
    id: "r14",
    userId: "u14",
    userName: "杨帆",
    templateId: "s5",
    templateName: "日出峰顶",
    templateType: "style",
    styleName: "写实风格",
    imageUrl: "/assets/img/d4e60801f4a686c0.jpg",
    status: "success",
    stage: "published",
    provider: "wan",
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    validationScore: 0.86,
    validationThreshold: 0.4,
    createdAt: "2026-06-01 11:08:17",
    generateTime: 2.5,
    faceScore: 92,
  },
  {
    id: "r15",
    userId: "u15",
    userName: "何静",
    templateId: "p9",
    templateName: "三峡人家",
    templateType: "pure",
    sceneType: "山水风景",
    imageUrl: "/assets/img/ccc2408a2d637afa.jpg",
    status: "success",
    stage: "published",
    provider: "facefusion",
    validationPolicyId: "direct-publish-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    createdAt: "2026-06-01 10:45:29",
    generateTime: 1.9,
    faceScore: 95,
  },
  {
    id: "r16",
    userId: "u16",
    userName: "高飞",
    templateId: "p10",
    templateName: "西陵峡",
    templateType: "pure",
    sceneType: "山水风景",
    imageUrl: "/assets/img/400261a6ef52dadf.jpg",
    status: "success",
    stage: "published",
    provider: "wan",
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    validationScore: 0.89,
    validationThreshold: 0.4,
    createdAt: "2026-06-01 10:22:10",
    generateTime: 2.2,
    faceScore: 93,
  },
  {
    id: "r17",
    userId: "u17",
    userName: "田甜",
    templateId: "p11",
    templateName: "宜昌长江大桥",
    templateType: "pure",
    sceneType: "城市风光",
    imageUrl: "/assets/img/a2620de0cd6cbb0b.jpg",
    status: "success",
    stage: "published",
    provider: "facefusion",
    validationPolicyId: "direct-publish-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    createdAt: "2026-06-01 09:58:44",
    generateTime: 2.7,
    faceScore: 90,
  },
  {
    id: "r18",
    userId: "u18",
    userName: "谢军",
    templateId: "s8",
    templateName: "古风卡通",
    templateType: "style",
    styleName: "卡通插画",
    imageUrl: "/assets/img/44ada57bef8376f0.jpg",
    status: "success",
    stage: "published",
    provider: "facefusion",
    validationPolicyId: "direct-publish-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    createdAt: "2026-06-01 09:35:12",
    generateTime: 1.6,
    faceScore: 87,
  },
  {
    id: "r19",
    userId: "u19",
    userName: "韩冰",
    templateId: "p12",
    templateName: "张飞庙",
    templateType: "pure",
    sceneType: "名胜古迹",
    imageUrl: "/assets/img/3f42c42b98c0fe5c.jpg",
    status: "success",
    stage: "published",
    provider: "wan",
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    validationScore: 0.91,
    validationThreshold: 0.4,
    createdAt: "2026-06-01 09:10:55",
    generateTime: 2.1,
    faceScore: 96,
  },
  {
    id: "r20",
    userId: "u20",
    userName: "唐丽",
    templateId: "p13",
    templateName: "三峡日落",
    templateType: "pure",
    sceneType: "日出日落",
    imageUrl: "/assets/img/dfd36f03d2fd1760.jpg",
    status: "success",
    stage: "published",
    provider: "wan",
    validationPolicyId: "wan-photo-v1",
    validationEnabled: true,
    generationAttempt: 1,
    maxGenerationAttempts: 3,
    validationScore: 0.87,
    validationThreshold: 0.4,
    createdAt: "2026-06-01 08:48:30",
    generateTime: 2.4,
    faceScore: 94,
  },
];
